import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from './api.service';
import { Schedule, ScheduleRequest } from '../models';
import { HelperService } from './helper.service';

@Injectable({ providedIn: 'root' })
export class ScheduleService {
  url = '/schedule';
  request: ScheduleRequest;
  viewDate: Date = new Date();

  constructor(private apiService: ApiService, private helperService: HelperService) {
    this.request = Object.assign({}, this.helperService.request);
  }

  get(): Observable<Schedule[]> {
    return this.apiService.post(`${this.url}/search`, this.request).pipe(map(data => data.data));
  }
}
